import { gql, useMutation } from '@apollo/client'
import { useAlert } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { accountsClient } from '../../../../utils/apollo/api'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation RemoveProfile($id: Int) {
    removeProfile(id: $id)
  }
`

export const useRemoveProfile = () => {
  const modal = useAlert()
  const id = useModalData()
  const closeModal = useCloseModal()
  const { t } = useTranslation('common')
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Profiles'], client: accountsClient })

  const handleRequest = () => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        closeModal()
      }
    })
  }

  return [handleRequest, state]
}
